/* Cover hero — slide show.
   Cross-fades slides, drives the numbered rail, autoplays, and pauses when
   the pointer is over the hero, when a control has focus, when the tab is
   hidden, or when the hero scrolls out of view. Supports swipe + arrow keys.
   Autoplay is deliberately kept even under prefers-reduced-motion (only the
   scale/zoom motion is dropped, handled in CSS). */

(function () {
  function initHero(root) {
    if (root.getAttribute("data-ch-ready")) return;
    root.setAttribute("data-ch-ready", "1");

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-ch-slide]"));
    var btns = Array.prototype.slice.call(root.querySelectorAll("[data-ch-nav]"));
    var fills = Array.prototype.slice.call(root.querySelectorAll("[data-ch-fill]"));
    if (slides.length < 1) return;

    var speed = parseInt(root.getAttribute("data-ch-speed"), 10) || 6;
    var wantAutoplay = root.getAttribute("data-ch-autoplay") === "true" && slides.length > 1;
    var index = slides.findIndex(function (s) {
      return s.classList.contains("is-active");
    });
    if (index < 0) index = 0;

    var timer = null;
    var hovering = false;
    var focused = false;
    var visible = true;

    function fillRail(i) {
      fills.forEach(function (f, n) {
        f.style.transition = "none";
        f.style.width = n < i ? "100%" : "0%";
      });
      var active = fills[i];
      if (!active) return;
      active.style.transition = "none";
      active.style.width = "0%";
      // two frames so the browser registers the reset before animating
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (i !== index) return;
          active.style.transition = "width " + speed + "s linear";
          active.style.width = "100%";
        });
      });
    }

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle("is-active", n === index);
      });
      btns.forEach(function (b, n) {
        b.classList.toggle("is-active", n === index);
        b.setAttribute("aria-selected", n === index ? "true" : "false");
      });
      fillRail(index);
    }

    function next() {
      show(index + 1);
    }

    function start() {
      stop();
      if (!wantAutoplay || hovering || focused || !visible) return;
      timer = setInterval(next, speed * 1000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    btns.forEach(function (b, n) {
      b.addEventListener("click", function () {
        show(n);
        start();
      });
    });

    root.addEventListener("mouseenter", function () {
      hovering = true;
      stop();
    });
    root.addEventListener("mouseleave", function () {
      hovering = false;
      start();
    });
    root.addEventListener("focusin", function () {
      focused = true;
      stop();
    });
    root.addEventListener("focusout", function () {
      focused = false;
      start();
    });

    document.addEventListener("visibilitychange", function () {
      visible = !document.hidden;
      if (visible) start();
      else stop();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") show(index + 1);
      else if (e.key === "ArrowLeft") show(index - 1);
    });

    // swipe
    var x0 = null;
    root.addEventListener(
      "touchstart",
      function (e) {
        x0 = e.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      "touchend",
      function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
        x0 = null;
      },
      { passive: true }
    );

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            visible = en.isIntersecting;
            if (visible) start();
            else stop();
          });
        },
        { threshold: 0.1 }
      ).observe(root);
    }

    show(index);
    start();
  }

  function boot() {
    document.querySelectorAll("[data-cover-hero]").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.addEventListener("load", boot);
  document.addEventListener("shopify:section:load", boot);
})();
